import { CREATE_REACTION } from '../actions';
import { postReaction } from '../api';
import { reactionForItem } from '../selectors';
import { currentUserId } from '../../selectors/user';
import { analyticsTrackEvent } from '../../utils/analytics';
import { ADD_REACTION_2 } from '../../constants/analytics';
import { getCurrentSpaceId } from '../../selectors/space';
import { isMaterialRbacEnabled } from '../../materials/permissions';

const COMMON_ROOM_REACTION_ITEM_TYPE = 'commonRoom';
const MATERIAL_REACTION_ITEM_TYPE = 'Material';

export const reactionAnalyticsProperties = (state, params) => {
  const analyticsContext = () => ({
    spaceId: getCurrentSpaceId(state),
    isRbacEnabled: isMaterialRbacEnabled(state),
  });

  switch (params.itemType) {
    case 'UBClassRoomPost':
      return {
        ...analyticsContext(),
        itemType: COMMON_ROOM_REACTION_ITEM_TYPE,
        itemId: '',
        postId: params.itemId,
      };
    case 'UBComment': {
      const comment = state.data.comments?.[params.itemId];
      if (comment?.entityType === 'material') {
        return {
          ...analyticsContext(),
          itemType: MATERIAL_REACTION_ITEM_TYPE,
          itemId: comment.entityId,
          commentId: params.itemId,
        };
      }
      if (comment?.entityType === 'post') {
        return {
          ...analyticsContext(),
          itemType: COMMON_ROOM_REACTION_ITEM_TYPE,
          itemId: '',
          postId: comment.entityId,
          commentId: params.itemId,
        };
      }
      return null;
    }
    default:
      return null;
  }
};

const createReactionStarted = (dispatch, payload) =>
  dispatch({
    type: CREATE_REACTION,
    status: 'started',
    payload,
  });

const createReactionSuccess = (dispatch, payload) =>
  dispatch({
    type: CREATE_REACTION,
    status: 'success',
    payload,
  });

const createReactionError = (dispatch, payload) =>
  dispatch({
    type: CREATE_REACTION,
    status: 'error',
    payload,
  });

const createReaction = (params) => async (dispatch, getState) => {
  const state = getState();
  const oldReaction = reactionForItem(state, params);
  const user = currentUserId(state);
  createReactionStarted(dispatch, {
    oldReaction,
    params,
    user,
  });
  try {
    const reaction = await postReaction(params);
    const analyticsProperties = reactionAnalyticsProperties(state, params);
    if (analyticsProperties) {
      analyticsTrackEvent(ADD_REACTION_2, analyticsProperties);
    }
    createReactionSuccess(dispatch, {
      reaction,
      params,
      user,
      local: true,
    });
    return reaction;
  } catch (error) {
    createReactionError(dispatch, {
      params,
      error,
      oldReaction,
      user,
    });
    throw error;
  }
};

export default createReaction;
